<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        @if (modeService.isIosMode()) {
        <div>Abbrechen</div>
        } @if (!modeService.isIosMode()) {
        <div>
          <ion-icon
            name="close-outline"
            slot="icon-only"
            size="large"
          ></ion-icon>
        </div>
        }
      </ion-button>
    </ion-buttons>
    <ion-title>Fahrschüler</ion-title>
    <ion-buttons slot="end">
      <ion-button
        (click)="save()"
        [disabled]="!this.studentForm.valid"
        [strong]="true"
        >Speichern</ion-button
      >
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <form [formGroup]="studentForm" class="bg-iosbackground dark:bg-transparent">
    @if ((studentForm.value?.profile_picture === null && studentForm.value?.profile_picture_url === null) || !studentForm.value?.has_profile_picture) {
      <div class="w-full grid justify-center p-5">
        <div
          [style.background-color]="getColor(studentForm.value)"
          class="avatar mr-3 relative inline-flex items-center justify-center w-14 h-14 overflow-hidden rounded-full"
          (click)="addProfilePicture()"
        >
          <span class="font-semibold text-xl text-white dark:text-gray-300">{{
            studentForm.value?.forename.substring(0, 1) || "F"
          }}</span>
        </div>
      </div>
    }
    @else {
      <div class="w-full grid justify-center p-5">
        <img
          class="avatar mr-3 relative inline-flex items-center justify-center w-14 h-14 overflow-hidden rounded-full"
          (click)="addProfilePicture()"
          [src]="studentForm.value?.profile_picture?.webPath || studentForm.value?.profile_picture_url"
          [alt]="studentForm.value?.forename || null"
        />
      </div>
    }
    <ion-list lines="full" class="mb-5">
      @if (showImportContactButton) {
      <ion-item button (click)="importContact()" detail="true" class="sticky">
        <ion-icon name="people-outline" slot="start"></ion-icon>
        <ion-label>Aus Kontakten importieren</ion-label>
      </ion-item>
      }
      <ion-item button (click)="scanLfa()" detail="true" class="sticky">
          <ion-icon name="scan-outline" slot="start"></ion-icon>
          <ion-label>Lernfahrausweis scannen</ion-label>
      </ion-item>
    </ion-list>
    <ion-list>
      <ion-item>
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="person-outline"
            class="text-lg"
          ></ion-icon>
        </ion-note>
        <ion-input formControlName="forename" placeholder="Vorname"></ion-input>
      </ion-item>
      <ion-item lines="full">
        <ion-note slot="start">
          <ion-icon color="primary" class="text-lg"></ion-icon>
        </ion-note>
        <ion-input formControlName="surname" placeholder="Nachname"></ion-input>
      </ion-item>
    </ion-list>
    <ion-list class="mt-5 mb-5">
      <ion-item>
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="location-outline"
            class="text-lg"
          ></ion-icon>
        </ion-note>
        <ion-input formControlName="street" placeholder="Strasse"></ion-input>
      </ion-item>
      <ion-row>
        <ion-col>
          <ion-item lines="full">
            <ion-note slot="start">
              <ion-icon color="primary" class="text-lg"></ion-icon>
            </ion-note>
            <ion-input
              formControlName="postal_code"
              placeholder="Postleitzahl"
            ></ion-input>
          </ion-item>
        </ion-col>
        <ion-col>
          <ion-item lines="full">
            <ion-input formControlName="city" placeholder="Ort"></ion-input>
            <ion-note slot="end">
              <ion-icon color="primary" class="text-lg"></ion-icon>
            </ion-note>
          </ion-item>
        </ion-col>
      </ion-row>
    </ion-list>
    <ion-list class="mt-5 mb-5">
      <ion-item>
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="call-outline"
            class="text-lg"
          ></ion-icon>
        </ion-note>
        <ion-input
          placeholder="Telefonnummer"
          formControlName="mobile_no"
          placeholder="+41 xx xxx xx xx"
          [maskito]="phoneMask"
          [maskitoElement]="maskPredicate"
        ></ion-input>
      </ion-item>
      <ion-item lines="full">
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="mail-outline"
            class="text-lg"
          ></ion-icon>
        </ion-note>
        <ion-input
          formControlName="mail_student"
          placeholder="Email"
          email
        ></ion-input>
      </ion-item>
    </ion-list>
    <ion-list class="mt-5 mb-5">
      <ion-item lines="full">
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="calendar-outline"
            class="text-lg"
          ></ion-icon>
        </ion-note>
        <ion-input
          label="Geburtstag"
          formControlName="birthday"
          placeholder="Geburtstag"
          type="date"
        ></ion-input>
      </ion-item>
    </ion-list>
    <ion-list class="mt-5 mb-5">
      <ion-item lines="full">
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="pin-outline"
            class="text-lg"
          ></ion-icon>
        </ion-note>
        <ion-input
          formControlName="location"
          placeholder="Treffpunkt"
        ></ion-input>
        <ion-button 
          fill="clear" 
          slot="end" 
          (click)="copyAddressToMeetingPoint()"
          title="Adresse als Treffpunkt übernehmen">
          <ion-icon name="copy-outline" color="primary"></ion-icon>
        </ion-button>
      </ion-item>
      <ion-item lines="full">
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="school-outline"
            class="text-lg"
          ></ion-icon>
        </ion-note>
        <ion-input
          formControlName="exam_location"
          placeholder="Prüfungsort"
        ></ion-input>
      </ion-item>
    </ion-list>
    <ion-list class="mt-5 mb-5">
      <ion-item>
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="car-outline"
            class="text-lg"
          ></ion-icon>
        </ion-note>
        <ion-select
          label="Kategorie"
          aria-label="Kategorie"
          formControlName="category"
          value="B"
          okText="Festlegen"
          cancelText="Abbrechen"
        >
          <ion-select-option value="A">A</ion-select-option>
          <ion-select-option value="-A">-A</ion-select-option>
          <ion-select-option value="A1">A1</ion-select-option>
          <ion-select-option value="B">B</ion-select-option>
          <ion-select-option value="BE">BE</ion-select-option>
          <ion-select-option value="B1">B1</ion-select-option>
          <ion-select-option value="C">C</ion-select-option>
          <ion-select-option value="CE">CE</ion-select-option>
          <ion-select-option value="C1">C1</ion-select-option>
          <ion-select-option value="C1E">C1E</ion-select-option>
          <ion-select-option value="D">D</ion-select-option>
          <ion-select-option value="DE">DE</ion-select-option>
          <ion-select-option value="D1">D1</ion-select-option>
          <ion-select-option value="D1E">D1E</ion-select-option>
        </ion-select>
      </ion-item>
      @if (studentForm.value?.category === "B" || studentForm.value?.category === "BE") {
      <ion-item [lines]="!studentForm.value?.vku_completed ? 'full' : ''">
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="checkmark-circle-outline"
            class="text-lg"
          ></ion-icon>
        </ion-note>
        <ion-checkbox 
          class="w-full m-0"
          formControlName="vku_completed"
          slot="end"
        >VKU absolviert</ion-checkbox>
      </ion-item>

      @if (studentForm.value?.vku_completed) {
      <ion-item lines="full">
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="calendar-outline"
            class="text-lg"
          ></ion-icon>
        </ion-note>
        <ion-input
          label="VKU-Datum (optional)"
          formControlName="vku_date"
          placeholder="VKU absolviert am"
          type="date"
        ></ion-input>
      </ion-item>
      }
      }
    </ion-list>
    <ion-list class="mt-5-mb-5">
      <ion-item-divider>
        <ion-label>Lernfahrausweis</ion-label>
      </ion-item-divider>
      <ion-item>
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="calendar-outline"
            class="text-lg"
          ></ion-icon>
        </ion-note>
        <ion-input
          label="LFA gültig von"
          formControlName="lfa_start"
          placeholder="LFA gültig von"
          type="date"
        ></ion-input>
      </ion-item>
      <ion-item>
        <ion-note slot="start">
          <ion-icon
            color="primary"
            class="text-lg"
          ></ion-icon>
        </ion-note>
        <ion-input
          label="LFA gültig bis"
          formControlName="lfa_end"
          placeholder="LFA gültig bis"
          type="date"
        ></ion-input>
      </ion-item>
      <ion-item>
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="id-card-outline"
            class="text-lg"
          ></ion-icon>
        </ion-note>
        <ion-input
          formControlName="lfa_number"
          placeholder="LFA-Nummer"
        ></ion-input>
      </ion-item>
      
      <ion-row>
        <ion-col>
          <ion-item lines="full">
            <ion-note slot="start">
              <ion-icon
                color="primary"
                class="text-lg"
              ></ion-icon>
            </ion-note>
            <ion-input
              formControlName="lfa_pin"
              placeholder="Pin"
            ></ion-input>
          </ion-item>
        </ion-col>
        <ion-col>
          <ion-item lines="full">
            <ion-input
              formControlName="lfa_pid"
              placeholder="PID"
            ></ion-input>
            <ion-note slot="end">
              <ion-icon
                color="primary"
                class="text-lg"
              ></ion-icon>
            </ion-note>
          </ion-item>
        </ion-col>
      </ion-row>
    </ion-list>
    <ion-list class="mt-5 mb-5">
      <ion-item lines="full">
        <ion-icon
          color="primary"
          name="document-text-outline"
          class="text-lg mr-4"
        ></ion-icon>
        <ion-textarea
          class="textarea"
          placeholder="Notiz"
          autoGrow
          formControlName="notes"
        >
        </ion-textarea>
      </ion-item>
    </ion-list>
    <ion-list class="mt-5 mb-5">
      <input
        #fileUpload
        type="file"
        multiple
        id="file-upload"
        (change)="onFileChange($event)"
        class="!hidden"
      />
      <ion-item button (click)="fileUpload.click()" lines="full">
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="attach-outline"
            class="text-lg"
          ></ion-icon>
        </ion-note>
        <ion-label>{{ fileUpload.files?.length === 1 ? fileUpload.files[0].name : fileUpload.files?.length === 0 ? 'Anhang hinzufügen' : fileUpload.files?.length + ' Dateien ausgewählt' }}</ion-label>
      </ion-item>
    </ion-list>
  </form>
</ion-content>
